"use client";

export default function NewsImageThumbnail({
  src,
  alt,
}: {
  src?: string;
  alt: string;
}) {
  return (
    <img
      src={src ?? "/whale-icon.png"}
      alt={alt}
      className="w-full h-full object-contain rounded-sm p-2"
      onError={(e) => {
        // Fallback to Lattice logo on error
        if (e.target instanceof HTMLImageElement) {
          e.target.src = "/whale-icon.png";
        }
      }}
    />
  );
}
